import { Component, Input } from '@angular/core';

@Component({
  selector: 'ta-badge',
  templateUrl: './ta-badge.component.html',
  styleUrls: ['./ta-badge.component.scss']
})
export class TaBadgeComponent {
  @Input() value: string;
  @Input() color: string;
}
